function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "6.6078186%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3D09D7",
  stopOpacity: 0.5,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  stopOpacity: 0.5,
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-2",
  x: 0,
  y: 0,
  width: 512,
  height: 512,
  rx: 110
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "amazon_music"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#3D09D7",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53.000000, 170.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M373.410667,157.111111 C360.098667,157.111111 344.283556,160.424889 332.635556,168.730667 C329.307556,171.219556 329.307556,174.533333 333.474667,174.533333 C346.786667,172.869333 376.752889,168.730667 382.569778,176.197333 C387.561778,182.839111 376.738667,211.056 371.746667,224.325333 C370.082667,228.478222 373.410667,229.303111 376.738667,226.814222 C399.209778,207.728 405.026667,168.716444 400.873778,163.738667 C398.370667,159.6 386.722667,157.111111 373.410667,157.111111 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.0222222,168.488889 C31.7644444,184.602667 57.791111,199.991111 85.112,211.610667 C112.333333,223.201778 140.891556,231.493333 169.592,231.607111 C198.818667,232.389333 228.500444,228.378667 257.300444,221.822222 C286.2,215.166222 314.36,205.139556 342.022222,193.406222 C345.634667,191.856 349.830222,193.548444 351.366222,197.160889 C352.788444,200.503111 351.451556,204.343111 348.379556,206.135111 C321.542222,221.623111 292.514667,233.626667 262.278222,241.761778 C231.956444,249.896889 200.639111,253.452444 168.937778,252.940444 C136.568,251.248 105.577778,241.392 77.844444,227.041778 C50.04,212.620444 24.7955556,194.472889 1.7413333,174.177778 C0.2622222,172.869333 0.12,170.622222 1.4142222,169.143111 C2.6088889,167.820444 4.5715556,167.578667 6.0222222,168.488889 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.666667,128.666667 L175.920889,128.666667 C159.48,128.666667 146.111111,115.297778 146.111111,98.856889 L146.111111,43.333333 L160.333333,43.333333 L160.333333,98.856889 C160.333333,107.447111 167.330667,114.444444 175.920889,114.444444 L181.666667,114.444444 C190.242667,114.444444 203,101.687111 203,93.111111 L203,78.888889 L217.222222,78.888889 L217.222222,93.111111 C217.222222,109.722667 198.278222,128.666667 181.666667,128.666667 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 18.1111111,
  y: 43.333333,
  width: 14.2222222,
  height: 85.3333333
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.672,74.764444 C23.3733333,67.838222 25.7626667,62.092444 28.9626667,56.887111 C30.6266667,54.284444 32.4613333,51.795556 35.0497778,49.448889 C37.9226667,47.016889 41.2222222,45.424 44.6071111,44.343111 C58.601778,40.190222 73.208,48.680889 79.280889,61.352889 C82.452444,67.767111 82.153778,75.489778 82.111111,80.183111 L82.111111,96.339556 L82.111111,128.666667 L67.888889,128.666667 L67.888889,96.339556 L67.888889,80.183111 C67.917333,74.195556 68.002667,70.739556 66.352889,67.297778 C63.380444,60.215111 54.605333,57.072 47.366222,57.285333 C41.0231111,57.015111 32.5324444,67.098667 30.7688889,74.764444 L23.672,74.764444 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.444444,74.764444 C71.145778,67.838222 73.535111,62.092444 76.735111,56.887111 C78.399111,54.284444 80.233778,51.795556 82.822222,49.448889 C85.695111,47.016889 88.994667,45.424 92.379556,44.343111 C106.374222,40.190222 120.980444,48.680889 127.053333,61.352889 C130.224889,67.767111 129.926222,75.489778 129.883556,80.183111 L129.883556,96.339556 L129.883556,128.666667 L115.661333,128.666667 L115.661333,96.339556 L115.661333,80.183111 C115.689778,74.195556 115.775111,70.739556 114.125333,67.297778 C111.152889,60.215111 102.377778,57.072 95.138667,57.285333 C88.795556,57.015111 80.304889,67.098667 78.541333,74.764444 L71.444444,74.764444 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 203,
  y: 43.333333,
  width: 14.2222222,
  height: 85.3333333
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 302.555556,
  y: 43.333333,
  width: 14.2222222,
  height: 85.3333333
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 309.666667,
  cy: 14.888889,
  r: 14.2222222
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.222222,80.595556 L345.222222,91.404444 C345.222222,104.062222 355.604444,114.444444 368.262222,114.444444 C374.377778,114.444444 380.208889,112.026667 384.617778,107.76 L387.888889,104.488889 L387.888889,122.977778 C382.057778,126.675556 375.373333,128.666667 368.262222,128.666667 C347.782222,128.666667 331,111.884444 331,91.404444 L331,80.595556 C331,60.115556 347.782222,43.333333 368.262222,43.333333 C375.373333,43.333333 382.057778,45.324444 387.888889,49.022222 L387.888889,67.511111 L384.617778,64.24 C380.208889,59.973333 374.377778,57.555556 368.262222,57.555556 C355.604444,57.555556 345.222222,67.937778 345.222222,80.595556 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.151111,56.915556 C247.728889,57.911111 245.666667,60.826667 245.666667,64.666667 C245.666667,72.915556 250.217778,75.333333 262.164444,79.315556 C273.257778,82.871111 288.333333,87.991111 288.333333,107.333333 C288.333333,114.728889 285.488889,120.844444 279.942222,125.111111 C272.973333,130.515556 262.448889,132.222222 252.351111,132.222222 C244.671111,132.222222 236.991111,131.226667 231.444444,130.231111 L231.444444,115.724444 C244.813333,118.426667 263.871111,119.706667 271.124444,113.875556 C272.546667,112.88 274.111111,111.173333 274.111111,107.333333 C274.111111,99.084444 269.56,96.666667 257.613333,92.684444 C246.52,89.128889 231.444444,84.008889 231.444444,64.666667 C231.444444,57.271111 234.288889,51.155556 239.835556,46.888889 C252.208889,37.217778 272.646222,39.792 285.247111,44.556444 L285.247111,59.063111 C272.077333,51.468444 256.404444,51.084444 249.151111,56.915556 Z",
  id: "Path"
}))));

function SvgAmazonMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonMusic);
export default __webpack_public_path__ + "static/media/amazon_music.dfd7504a.svg";
export { ForwardRef as ReactComponent };